import { useCallback } from 'react';
import { Info } from 'lucide-react';
import { useStore } from '../hooks/useStore';
import useTranslation from '../hooks/useTranslation';
import TextInputAndLabel from '../components/TextInputAndLabel';
import imeikeypad from '@/public/assets/imeikeypad.png';

const DeviceIdentifierTextInput = () => {
  const selectedDeviceType = useStore((state) => state.selectedDeviceType);
  const deviceIdentifier = useStore((state) => state.deviceIdentifier);
  const deviceIdentifierValid = useStore(
    (state) => state.deviceIdentifierValid,
  );
  const setDeviceIdentifier = useStore((state) => state.setDeviceIdentifier);
  const deviceIdentifierError = useStore(
    (state) => state.deviceIdentifierError,
  );

  const translations = useTranslation();

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setDeviceIdentifier(e.currentTarget.value);
    },
    [setDeviceIdentifier],
  );

  const error = deviceIdentifierError
    ? deviceIdentifierError.ErrorCode === 'DeviceIdentifierInvalid' ||
      deviceIdentifierError.ErrorCode === 'DeviceIdentifierInvalidLength' ||
      deviceIdentifierError.ErrorCode === 'DeviceAlreadyRegistered'
      ? translations[`deviceIdentifierError.${deviceIdentifierError.ErrorCode}`]
      : translations['deviceIdentifierError.UnknownError']
    : null;

  return (
    <section>
      {selectedDeviceType === 'mobile' ? (
        <>
          <TextInputAndLabel
            id="deviceIdentifier"
            label={translations['imeiNumber']}
            placeholder={translations['imeiPlaceholder']}
            error={error}
            value={deviceIdentifier}
            valid={deviceIdentifierValid}
            onChange={onChange}
          />
          <div className="flex flex-col sm:flex-row gap-4 my-4 items-center">
            <img src={imeikeypad} alt="" className="w-26 h-auto border" />
            <div className="flex flex-col gap-2 text-base">
              <div className="flex gap-2">
                <Info size={25} />
                <p className="font-samsungOneBold">
                  {translations.modelImeiTitel}
                </p>
              </div>
              <ol className="grid gap-2 list-none text-left text-sm">
                <li>
                  {translations.modelImeiStep1Prefix}
                  <span className="font-samsungOneBold bg-gray-100 px-2 py-0.5 rounded">
                    *#06#
                  </span>
                  {translations.modelImeiStep1Suffix}
                </li>
                <li className="text-base">{translations.modelImeiStep2}</li>
              </ol>
            </div>
          </div>
        </>
      ) : (
        <TextInputAndLabel
          id="deviceIdentifier"
          label={translations['serialNumber']}
          error={error}
          value={deviceIdentifier}
          valid={deviceIdentifierValid}
          onChange={onChange}
        />
      )}
    </section>
  );
};

export default DeviceIdentifierTextInput;
